import React from 'react';

import { Button, Tooltip, Icons } from '~/components';

const ButtonDownloadFileManager = ({
  onClick,
  loading = false,
  disabled = false,
  'aria-label': ariaLabel = 'Baixar anexo',
}) => (
  <Tooltip title={loading ? 'Download em andamento' : 'Download'}>
    <span>
      <Button
        shape="circle"
        onClick={onClick}
        type="primary"
        loading={loading}
        disabled={disabled || loading}
        icon={loading ? undefined : <Icons.DownloadOutlined aria-hidden />}
        style={{ margin: '9px' }}
        aria-label={loading ? 'Download em andamento' : ariaLabel}
      />
    </span>
  </Tooltip>
);

export default ButtonDownloadFileManager;
